





































import { Vue, Component } from 'vue-property-decorator'
import VueBase from '@/lib/vuebase'
import ajax from '@/lib/ajax'
import util from '@/lib/util'
import pageRequest from '@/store/models/page-request'
import { Dialog } from 'vant'
@Component({})
export default class BlackListManager extends VueBase {
	loading: boolean = false
	finished: boolean = false
	error: boolean = false
	totalCount: number = 0
	blackList: Array<any> = []
	searchForm: pageRequest = new pageRequest()
	onClickLeft() {
		window.history.go(-1)
	}
	// 页面初次加载
	async onLoad() {
		this.error = false
		this.searchForm.page += 1
		if (this.totalCount !== 0 && this.blackList.length === this.totalCount) return
		await this.searchBlackList()
	}
	// 查询数据
	async searchBlackList() {
		await ajax
			.get('/api/blacklist/list-page', { params: this.searchForm })
			.then((rep) => {
				this.blackList.push(...rep.data.result.items)
				this.totalCount = rep.data.result.total
				if (this.blackList.length === this.totalCount) this.finished = true
			})
			.catch(() => {
				this.error = false
			})
			.finally(() => {
				this.loading = false
			})
	}
	addNew() {
		this.$router.push({ path: '/blackListDetail' })
	}
	async relieveBtn(val: any) {
		Dialog.confirm({
			title: '提示',
			message: '确定撤回吗',
		})
			.then(async () => {
				await ajax.post('/api/blacklist/relieve/' + val.id)
					.then(() => {
						this.$toast.success('解除成功')
						window.location.reload()
					})
			})
			.catch(() => { })
	}
	async created() {
		this.blackList = []
	}
}
